import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  public selectedLanguage: 'en' | 'heb' | null = null;

  constructor(private titleService: Title,
    private metaTagService: Meta) { }

  ngOnInit() {
    this.titleService.setTitle('Lcontrol - Privacy Policy');

    this.metaTagService.updateTag(
      {
        name: 'description',
        content: 'Privacy policy in English and Hebrew for Lcontrol website and services.'
      }
    );

    this.metaTagService.updateTag(
      {
        name: 'keywords',
        content: 'privacy policy, lcontrol, data collection, cookies, security, GDPR'
      }
    );
  }

  public openLanguagePolicy(language: 'en' | 'heb') {
    this.selectedLanguage = language;
  }
}
